/* tslint:disable */
export const VERSION = "44172161d4d1422ae2371b723b3aa29cc0020317 Tue Nov 3 19:55:03 2026 +0000";
